import { useState } from "react";
import { NavigationArrowIcon } from "@phosphor-icons/react";

const isMobile = () => typeof navigator !== "undefined" && /android|iphone|ipad|ipod/i.test(navigator.userAgent);

export default function DirectionsButton({ lat, lng, className = "", full = false }) {
  const [open, setOpen] = useState(false);
  if (lat == null || lng == null) return null;
  const google = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  const apple = `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`;
  const base = "inline-flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-semibold transition-colors border border-slate-300 bg-white text-slate-700 hover:bg-slate-50";

  if (!isMobile()) {
    return (
      <a data-testid="get-directions" href={google} target="_blank" rel="noreferrer" className={`${base} ${full ? "w-full" : ""} ${className}`}>
        <NavigationArrowIcon size={16} weight="fill" className="text-emerald-600" /> Get Directions
      </a>
    );
  }

  return (
    <div className={`relative ${full ? "w-full" : ""} ${className}`}>
      <button data-testid="get-directions" onClick={() => setOpen((o) => !o)} className={`${base} ${full ? "w-full" : ""}`}>
        <NavigationArrowIcon size={16} weight="fill" className="text-emerald-600" /> Get Directions
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-[1290]" onClick={() => setOpen(false)} />
          <div className="absolute z-[1300] mt-1 w-56 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-xl">
            <a data-testid="dir-google" href={google} target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="block px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50">Open in Google Maps</a>
            <a data-testid="dir-apple" href={apple} target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="block border-t border-slate-100 px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50">Open in Apple Maps</a>
          </div>
        </>
      )}
    </div>
  );
}
